module.exports = __webpack_public_path__ + "static/media/image3.bdfcdfe3.jpg";